import React, { Component } from 'react'
import classes from './NavigationItems.module.css'
import NavigationItem from './NavigationItem/NavigationItem'
import {Link} from "react-router-dom"
import {connect } from 'react-redux'
import * as actions from '../../../Store/Action/index'
import SideBarToggle from '../SidebarToggle/SidebarToggle'


class NavigationItems extends Component {

    render(){
        let value= null
        if(!this.props.isAuth){
           value = {"display":"none"}
        }
    return (

        <ul className={classes.NavigationItems}>
            
            <NavigationItem to={"/search/git"}>Books</NavigationItem>
            <NavigationItem to={"/course-material"}>Study Material</NavigationItem>
           <div className={classes.icons}><Link to='/'>
               <i className="fa fa-search"></i>     
           </Link>
           </div>
           <div className={classes.icons}>
             <Link to = "/register"> <i className="fa fa-user"></i>   </Link>  
             
           </div>
           <div className={classes.icons} style = {value}>
             <i onClick = {this.props.logout} > <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
          width="25" height="25"
          viewBox="0 0 172 172"
          style={{"fill":"#000000"}}><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style={{"mix-blend-mode":"normal"}}><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M86,10.75c-1.075,0 -2.0151,0.40365 -2.82135,1.2099l-20.15625,20.15625c-0.80625,0.80625 -1.2099,1.74635 -1.2099,2.82135c0,1.075 0.40365,2.0151 1.2099,2.82135c1.6125,1.6125 4.16457,1.6125 5.6427,0l13.30365,-13.30365v41.38855c0,2.28437 1.74688,4.03125 4.03125,4.03125c2.28437,0 4.03125,-1.74688 4.03125,-4.03125v-41.38855l13.30365,13.30365c1.6125,1.6125 4.16457,1.6125 5.6427,0c1.6125,-1.6125 1.6125,-4.16457 0,-5.6427l-20.15625,-20.15625c-0.80625,-0.80625 -1.74635,-1.2099 -2.82135,-1.2099zM33.67773,29.69635c-1.02461,0 -2.03242,0.40365 -2.77148,1.2099c-30.36875,30.36875 -30.36875,79.81875 0,110.1875c30.36875,30.36875 79.81875,30.36875 110.1875,0c15.18437,-15.18438 22.84375,-35.20625 22.84375,-55.09375c0,-19.8875 -7.65938,-39.90938 -22.84375,-55.09375c-1.6125,-1.6125 -4.16458,-1.6125 -5.6427,0c-1.6125,1.6125 -1.6125,4.16458 0,5.6427c27.27812,27.27812 27.27812,71.62187 0,98.76563c-27.27812,27.27812 -71.62187,27.27812 -98.76562,0c-27.27812,-27.14375 -27.28022,-71.4875 -0.13647,-98.76563c1.6125,-1.6125 1.6125,-4.16458 0,-5.6427c-0.80625,-0.80625 -1.84661,-1.2099 -2.87122,-1.2099zM86,81.96875c-2.2264,0 -4.03125,1.80485 -4.03125,4.03125c0,2.2264 1.80485,4.03125 4.03125,4.03125c2.2264,0 4.03125,-1.80485 4.03125,-4.03125c0,-2.2264 -1.80485,-4.03125 -4.03125,-4.03125z"></path></g></g></svg></i>  
          
           </div>
           
           
        </ul>

    )}
}
const mapStateToProps = (state)=>{
    return{
        isAuth:state.auth.isAuth
    }
}
const mapDispatchToProps = (dispatch)=>{
    return{
        logout:()=>dispatch(actions.logout())
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(NavigationItems)